module.exports = __webpack_public_path__ + "e3768a87bba4998451e01a53835f6740.png";